import { useEnterpriseSsoRequiredNotice, useOnboardingRedirect } from '@neo.tax/onboarding/hooks';
import { TestimonialMemo, StyledSplitScreen, EnterpriseSsoFormHeader } from '@neo.tax/onboarding/organisms';
import { Loader, Path, env, getPath } from '@neo.tax/shared';

import { EnterpriseSsoForm } from './organisms';

export const EnterpriseSso = (): React.ReactElement => {
  // Instances configured for enterprise SSO only redirect past the sign-in form, so this page is where their
  // users land after the backend clears a session it will not admit.
  useEnterpriseSsoRequiredNotice();

  return (
    <Loader useRedirect={useOnboardingRedirect}>
      <StyledSplitScreen
        leftSide={
          <EnterpriseSsoFormHeader
            pageChangeText="go back to"
            pageChangeLinkText="Login"
            pageChangeTo={getPath({ path: Path.LOGIN })}
            subtitleIsActive={env.REACT_APP_ENTERPRISE_SSO_LOGIN_ONLY === false}
            title="Enter your Provider ID"
            form={<EnterpriseSsoForm />}
          />
        }
        rightSide={<TestimonialMemo />}
      />
    </Loader>
  );
};
